import Vue from 'vue';

const isPostLiked    = Vue.observable({ value: false }),
      postLikedIcon  = () => 
            isPostLiked.value ? '/assets/images/icons/likes-red.svg' : '/assets/images/icons/likes.svg';

const handleLikePost = like => isPostLiked.value = like;

export { isPostLiked, postLikedIcon, handleLikePost }